export const GET_USERS = 'GET_USERS';
export const CLEAR_USERS = 'CLEAR_USERS';
export const UPDATE_USER = 'UPDATE_USER';

export const SET_IS_VIEWING_USER_DETAILS = 'SET_IS_VIEWING_USER_DETAILS';
export const SET_USER_BEING_VIEWED_INDEX = 'SET_USER_BEING_VIEWED_INDEX';

export const SET_TOTAL_PAGES = 'SET_TOTAL_PAGES';
export const SET_TOTAL_USERS = 'SET_TOTAL_USERS';
